<span matTooltip="Last Modification: {{object?.Modifier?.Email}} - {{object?.Modified | date: 'short'}}
Creation:&nbsp;{{object?.Creator?.Email}} - {{object?.Created | date: 'short'}}">
  <mat-icon>help</mat-icon>
</span>
